export default "__VITE_ASSET__Ddt4rKUe__"